import { useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import styled from "styled-components";

// Components
import LoadingTestResponse from "./components/LoadingTestResponse";
import QuestionsTest from "./components/bodyTest/QuestionsTest";
import BodyResults from "./components/BodyResults";
import BodyTest from "./components/BodyTest";

// Assets
import AcropolisLabImg from "../../assets/media/aden/acropolis-lab-rojo_logo.png"
import BackgroundTest from "../../assets/media/aden/background-test.png"

// Services
import { getTestInfo, getTestQuestionsOrAnswers } from "./services/testApi";

const Test = () => {

    const { test_id } = useParams();
    const { token } = useParams();

    const [page, setPage] = useState(0);
    const [loading, setLoading] = useState(false);
    const [answersFeedback, setAnswersFeedback] = useState(null)
    const [test, setTest] = useState(null)
    const [error, setError] = useState(false)
    const [questions, setQuestions] = useState(null)
    const [ondemandInfo, setOndemandInfo] = useState(null)

    useEffect(() => {
        let isMounted = true;
        !!test_id && setPage(0);
        !!token && setPage(1);
        fetchData(isMounted);
        return () => {
            isMounted = false;
        }
    }, [])

    const fetchData = async (isMounted) => {
        if (!!test_id) {
            try {
                const response = await getTestInfo(test_id);
                if (isMounted) {
                    setTest(response);
                }
            } catch (error) {
                console.log('error', error)
                setError(true);
            } finally {
                isMounted = false;
            }
        } else {
            try {
                setLoading(true);
                const response = await getTestQuestionsOrAnswers(token);
                if (response?.participant?.state === 'completed') {
                    setLoading(false);
                    setAnswersFeedback(response?.participant);
                    setTest(response?.skill_test)
                    setPage(2);
                }
                if (isMounted) {
                    setQuestions(response);
                    setOndemandInfo(response?.ondemand)
                    setTest(response?.skill_test)
                    setLoading(false);
                }
            } catch (error) {
                console.log('error', error)
                setError(true);
            } finally {
                isMounted = false;
            }
        }
    }

    const handleNextPage = () => {
        setLoading(true);
    }

    const handleFinalPage = (feedback) => {
        setLoading(false);
        setAnswersFeedback(feedback);
        setPage(2);
    }

    const handleShowPage = () => {
        switch (page) {
            case 0:
                return <BodyTest handleNextPage={handleNextPage} handleFinalPage={handleFinalPage} testId={test_id} test={test} />;
            case 1:
                return <QuestionsTest handleNextPage={handleNextPage} handleFinalPage={handleFinalPage} questions={questions?.participant?.questions} loading={loading} participant_id={questions?.participant?.id} />;
            case 2:
                return <BodyResults answersFeedback={answersFeedback} test={test} />;
            default:
                return null;
        }
    }

    return (
        <Container>
            <Header>
                <img src={AcropolisLabImg} alt="Acropolis Lab" height={60} />
                {
                    !!ondemandInfo?.logo && (
                        <img src={ondemandInfo?.logo} alt="Ondemand Img" height={60} />
                    )
                }
            </Header>
            <Body>
                {
                    loading
                        ? <LoadingTestResponse error={error} />
                        : handleShowPage()
                }
            </Body>
        </Container>
    );
}

export default Test;

const Container = styled.div`
    width: 100%;
    min-height: 100vh;
    height: 100%;
    background-image: url(${BackgroundTest});
    background-size: cover;
    background-position: center;
`

const Header = styled.div`
    width: 100%;
    height: 100px;
    background-color: #FFF;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 1rem;
`

const Body = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 3rem 0;
`